// extracted by mini-css-extract-plugin
module.exports = {"container":"cartIcon_container__3M5j-","amount":"cartIcon_amount__1iOYf"};